import React from 'react';
import { cn } from '../utils';

interface StatCardProps {
  label: string;
  value: string;
  icon: React.ReactNode;
  color: 'primary' | 'secondary' | 'accent';
}

export default function StatCard({ label, value, icon, color }: StatCardProps) {
  const colorMap = {
    primary: 'text-primary bg-primary/5',
    secondary: 'text-secondary bg-secondary/5',
    accent: 'text-accent bg-accent/5',
  };

  return (
    <div className="bg-surface group hover:border-primary/20 hover:shadow-primary/5 dark:hover:border-primary/40 relative flex flex-col justify-between overflow-hidden rounded-[2rem] border border-slate-100 p-6 transition-all duration-500 hover:scale-[1.02] hover:shadow-2xl dark:border-slate-800">
      {/* Subtle Glow Background */}
      <div className="bg-primary/0 group-hover:bg-primary/[0.02] pointer-events-none absolute inset-0 transition-colors duration-500" />

      <div className="mb-6 flex items-center justify-between">
        <div
          className={cn(
            'relative z-10 flex h-10 w-10 items-center justify-center rounded-xl',
            colorMap[color]
          )}
        >
          {icon}
        </div>
        <span className="relative z-10 text-[10px] font-black tracking-widest text-slate-400 uppercase dark:text-slate-500">
          {label}
        </span>
      </div>
      <div className="relative z-10 text-2xl font-black tracking-tighter text-slate-900 dark:text-white">
        {value}
      </div>
    </div>
  );
}
